import Vue from "vue";
import Vuex from "vuex";
import { VueReCaptcha } from "vue-recaptcha-v3";

import constants from "@/helpers/constants";
import admin from "./modules/admin";
import approverTypes from "./modules/approverTypes";
import areas from "./modules/areas";
import auth from "./modules/auth";
import contractItems from "./modules/contractItems";
import contracts from "./modules/contracts";
import demands from "./modules/demands";
import demandOwnerSubstitutions from "./modules/demandOwnerSubstitutions";
import demandTypes from "./modules/demandTypes";
import evaluations from "./modules/evaluations";
import events from "./modules/events";
import offices from "./modules/offices";
import persons from "./modules/persons";
import route from "./modules/route";
import searchFilter from "./modules/searchFilter";
import suppliers from "./modules/suppliers";
import systems from "./modules/systems";
import units from "./modules/units";

Vue.use(Vuex);
Vue.use(VueReCaptcha, {
    siteKey: "6LeDDpolAAAAAP8qzwRwK0j59EZp2mnUrFhT_aDr",
    loaderOptions: {
        useRecaptchaNet: false,
        autoHideBadge: true
    },
    explicitRenderParameters: {
        size: "invisible"
    }
});

export default new Vuex.Store({
    state: {
        status: constants.STORE_EMPTY
    },
    mutations: {
        setStatus(state, value) {
            state.status = value;
        }
    },
    actions: {
        async initialize({ commit, dispatch }) {
            commit("setStatus", constants.STORE_INITIALIZING);

            try {
                await dispatch("warmCache");
                commit("setStatus", constants.STORE_READY);
            } catch (e) {
                commit("setStatus", constants.STORE_EMPTY);
            }
        },
        async reset({ commit }) {
            commit("setStatus", constants.STORE_EMPTY);
        },
        async warmCache({ dispatch }) {
            if (auth.getters.isLoggedIn) {
                await Promise.all([
                    dispatch("loadApproverTypes"),
                    dispatch("loadAreas"),
                    dispatch("loadContractItems"),
                    dispatch("loadContracts"),
                    dispatch("loadDemands"),
                    dispatch("loadDemandOwnerSubstitutions"),
                    dispatch("loadDemandTypes"),
                    dispatch("loadOffices"),
                    dispatch("loadPersons"),
                    dispatch("loadSuppliers"),
                    dispatch("loadSystems"),
                    dispatch("loadUnits")
                ]);
                const timeout = setTimeout(() => {
                    clearTimeout(timeout);
                    dispatch("warmCache");
                }, 1000 * 60 * 5);
            }
        }
    },
    getters: {
        isStoreEmpty(state) {
            return state.status === constants.STORE_EMPTY;
        },
        isStoreInitializing(state) {
            return state.status === constants.STORE_INITIALIZING;
        }
    },
    modules: {
        admin,
        approverTypes,
        areas,
        auth,
        contractItems,
        contracts,
        demands,
        demandOwnerSubstitutions,
        demandTypes,
        evaluations,
        events,
        offices,
        persons,
        route,
        searchFilter,
        suppliers,
        systems,
        units
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js